import React, { useEffect, useState } from "react";
import {
  eventBus,
  toast,
  ToastTypes,
} from "../../../../components/ajonjolib/toasts/toast/toast";
import Modal from "../../../../components/ajonjolib/modal/modal/modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import styles from "./index.module.css";
import ModalFooter from "../../../../components/ajonjolib/modal/modal_footer/modal_footer";
import axiosInstance from "../../../../AxiosInstance";
import { parsePortAssignment } from "../../../../utils/utils";

function Amp({ settings, setSettings, ampUsage, ampLimit, portIs12Or24 }) {
  const availableAmp = ampLimit - ampUsage;

  return (
    <div className={"d-flex pt-3"}>
      <div className={styles.voltage}>{portIs12Or24 ? "12V" : "24V"}</div>
      <div>
        <div className={styles.item}>
          <div>Amperaje disponible</div>
          <div
            style={{ color: "#6A86C8", fontSize: "20px" }}
            className={"d-flex align-items-center"}
          >
            <div style={{ fontWeight: 600 }}>{availableAmp.toFixed(1)}</div>
            <div style={{ color: "#284480" }}>/</div>
            <div style={{ fontSize: "16px" }}>{ampLimit}</div>
          </div>
        </div>
        <div className={styles.item}>
          <div>Amperaje límite</div>
          <div
            style={{ color: "#6A86C8", fontSize: "20px" }}
            className={"d-flex align-items-center"}
          >
            <input
              className={styles["amp-input"]}
              type={"number"}
              step={0.1}
              min={0.1}
              max={20 - ampUsage}
              value={settings?.amp_limit}
              onChange={(event) => {
                setSettings({ ...settings, amp_limit: event.target.value });
              }}
            />
            <div className={"ps-2"} style={{ fontSize: "13px" }}>
              A
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Shutdown({ settings, setSettings }) {
  return (
    <div>
      <div className={styles.item}>
        <div>Chapa OFF</div>
        <div
          style={{ color: "#6A86C8", fontSize: "20px" }}
          className={"d-flex align-items-center"}
        >
          <input
            value={settings.shutdown_seconds}
            onChange={(event) => {
              setSettings({
                ...settings,
                shutdown_seconds: event.target.value,
              });
            }}
            min={0}
            max={600}
            type={"number"}
            style={{
              border: "#E2E5F4 1px solid",
              backgroundColor: "#F4F6FB",
              borderRadius: "10px",
              width: "98px",
              height: "38px",
              cursor: "text",
              display: "flex",
              alignItems: "center",
              paddingLeft: "20px",
            }}
          />
          <div className={"ps-2"} style={{ fontSize: "13px" }}>
            Segundos
          </div>
        </div>
      </div>
    </div>
  );
}

export default function OutputSettingsModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(null);
  const [section, setSection] = useState("amp");
  const [settings, setSettings] = useState({});
  const [ampUsage12v, setAmpUsage12v] = useState(0);
  const [ampUsage24v, setAmpUsage24v] = useState(0);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [outputNumber, setOutputNumber] = useState(0);
  const [ports12v, setPorts12v] = useState([]);
  const [ports24v, setPorts24v] = useState([]);
  const [ampLimit12v, setAmpLimit12v] = useState(0);
  const [ampLimit24v, setAmpLimit24v] = useState(0);
  const [error, setError] = useState("");

  useEffect(() => {
    if (data) {
      console.log("data from output_settings", data);
      setSettings({
        ...settings,
        amp_limit: data["amp_limits"][outputNumber - 1],
        shutdown_seconds: data["shutdown_seconds"][outputNumber - 1],
      });

      const ports12v = data["ports_12v"];
      const ports24v = data["ports_24v"];
      setPorts12v(ports12v);
      setPorts24v(ports24v);
      setAmpLimit12v(data["amp_limit_12v"]);
      setAmpLimit24v(data["amp_limit_24v"]);

      setAmpUsage12v(data.amp_usage_12v);
      setAmpUsage24v(data.amp_usage_24v);
    }
  }, [data]);

  useEffect(() => {
    eventBus.subscribe("output_settings_open", (rec_data) => {
      setIsOpen(true);
      setData(rec_data.data);
      setOutputNumber(rec_data.number);
    });
    eventBus.subscribe("output_settings_close", (rec_data) => {
      setIsOpen(false);
    });
  }, []);

  const checkAmpLimits = (voltage) => {
    const ports = voltage === "24v" ? ports24v : ports12v;
    const ampUsage = ports.reduce((total, port, _) => {
      if (port === outputNumber) {
        return total + parseInt(settings["amp_limit"], 10);
      } else {
        return total + data["amp_limits"][port - 1];
      }
    }, 0);
    const ampLimit = voltage === "24v" ? ampLimit24v : ampLimit12v;

    return ampUsage <= ampLimit;
  };

  const submit = () => {
    if (checkAmpLimits("24v") && checkAmpLimits("12v")) {
      setError("");
      setSubmitLoading(true);
      axiosInstance
        .put(`kpdu/${data.id}/output_settings/`, {
          ...settings,
          number: outputNumber,
        })
        .then((response) => {
          if (response?.status !== 200) {
            toast("Error al guardar los ajustes", ToastTypes.ERROR);
          }
          setSubmitLoading(false);
          setIsOpen(false);
        })
        .catch((response) => {
          toast("Error al guardar los ajustes", ToastTypes.ERROR);
        });
    } else {
      setError("No se puede exceder el límite de corriente.");
    }
  };

  return (
    <div>
      {isOpen && (
        <Modal
          close={() => {
            setIsOpen(false);
            setError("");
          }}
        >
          <div
            className={"d-flex justify-content-between mt-4 align-items-start"}
          >
            <div className={"d-flex"}>
              <svg
                width="31"
                height="62"
                viewBox="0 0 31 62"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 61.6H2.15139C4.5144 61.6 6.42965 59.6848 6.42965 57.3217V52.5707C7.66601 52.1769 8.85638 51.681 9.99206 51.0926L13.3529 54.4547C15.0229 56.1247 17.7324 56.1247 19.4024 54.4547L23.1539 50.7032C24.8239 49.0332 24.8239 46.3237 23.1539 44.6537L19.7919 41.2916C20.3802 40.157 20.8761 38.9667 21.2699 37.7304H26.021C28.384 37.7304 30.2992 35.8152 30.2992 33.4522V28.1478C30.2992 25.7848 28.384 23.8696 26.021 23.8696H21.2699C20.8761 22.6332 20.3802 21.4428 19.7918 20.3072L23.1539 16.9463C24.8239 15.2763 24.8239 12.5668 23.1539 10.8968L19.4024 7.14529C17.7324 5.47529 15.0229 5.47529 13.3529 7.14529L9.99087 10.5073C8.85625 9.91901 7.66593 9.42309 6.42965 9.02933V4.27826C6.42965 1.91525 4.5144 0 2.15139 0H0V0.3H2.15139C2.22286 0.3 2.29389 0.301884 2.36443 0.305605C2.29414 0.301911 2.22338 0.300049 2.15218 0.300049H0V3.25217H2.15139C2.71771 3.25217 3.17748 3.71195 3.17748 4.27826V10.2523C3.17748 10.994 3.68011 11.6411 4.39705 11.8264C6.1927 12.29 7.88932 13.0018 9.44752 13.9227C10.0864 14.2998 10.8995 14.1974 11.4247 13.6722L15.6525 9.44571C16.0523 9.04488 16.7016 9.04449 17.1031 9.44598L20.8532 13.1962C21.2547 13.5977 21.254 14.2472 20.8532 14.647L16.627 18.8746C16.1018 19.3998 15.9995 20.2129 16.3766 20.8518C17.2975 22.41 18.0092 24.1066 18.4728 25.9023C18.6582 26.6192 19.3052 27.1217 20.0469 27.1217H26.021C26.5873 27.1217 27.047 27.5815 27.047 28.1478V33.4522C27.047 34.0185 26.5873 34.4783 26.021 34.4783H20.0469C19.3052 34.4783 18.6582 34.9809 18.4728 35.6978C18.0092 37.4935 17.2974 39.1901 16.3766 40.7483C15.9994 41.3872 16.1018 42.2003 16.627 42.7255L20.8535 46.9533C21.2543 47.3531 21.2547 48.0023 20.8532 48.4038L17.1031 52.154C16.7016 52.5555 16.052 52.5548 15.6522 52.154L11.4247 47.9277C10.8995 47.4026 10.0863 47.3003 9.4474 47.6774C7.88921 48.5982 6.19261 49.31 4.39696 49.7736C3.68002 49.959 3.17748 50.606 3.17748 51.3477V57.3217C3.17748 57.8881 2.71771 58.3478 2.15139 58.3478H0V58.6478H2.15139C2.88339 58.6478 3.47748 58.0537 3.47748 57.3217V51.3477C3.47748 50.743 3.88724 50.2153 4.47205 50.0641C6.29541 49.5933 8.01801 48.8706 9.60003 47.9357C9.83528 47.7968 10.0994 47.7377 10.3579 47.7539C10.0997 47.7378 9.83582 47.797 9.60081 47.9357C8.01879 48.8706 6.2962 49.5934 4.47283 50.0641C3.88802 50.2153 3.47826 50.7431 3.47826 51.3478V57.3218C3.47826 58.0538 2.88417 58.6479 2.15218 58.6479H0V61.6ZM0 43.0254C6.52021 42.7619 11.7332 37.3851 11.7332 30.8007C11.7332 24.2163 6.52021 18.8395 0 18.576V21.5312C4.89028 21.7918 8.78185 25.8458 8.78185 30.8005C8.78185 35.0395 5.93333 38.6192 2.04792 39.7281C5.93293 38.619 8.78106 35.0394 8.78106 30.8007C8.78106 25.8463 4.88991 21.7924 0 21.5314V21.8319C4.72415 22.0925 8.48106 26.012 8.48106 30.8007C8.48106 35.5894 4.72415 39.5089 0 39.7695V42.725C0.489265 42.7047 0.97097 42.655 1.44337 42.5775C0.970968 42.655 0.489268 42.7048 0 42.7251V43.0254ZM10.0472 10.8753L10.0477 10.8756L13.5658 7.35747C14.4043 6.51897 15.5247 6.13324 16.6225 6.20028C15.5244 6.13301 14.4037 6.51872 13.565 7.35742L10.0472 10.8753ZM21.0502 24.1696L21.0503 24.1696H26.0217C26.0582 24.1696 26.0945 24.1701 26.1306 24.171C26.0942 24.1701 26.0576 24.1696 26.021 24.1696H21.0502ZM16.1217 55.399C15.1908 55.3392 14.2769 54.9537 13.5658 54.2426L10.049 50.7245L10.0485 50.7248L13.565 54.2426C14.2763 54.9539 15.1905 55.3394 16.1217 55.399ZM16.6349 20.6992C16.3273 20.178 16.4108 19.515 16.8391 19.0867L21.0654 14.8591C21.5839 14.3419 21.5839 13.5025 21.0654 12.984L17.3152 9.23385C17.0773 8.99596 16.7719 8.86722 16.461 8.84761C16.7721 8.86705 17.0779 8.99581 17.316 9.2339L21.0662 12.9841C21.5847 13.5026 21.5847 14.342 21.0662 14.8592L16.8399 19.0867C16.4116 19.515 16.328 20.1781 16.6357 20.6992C17.5706 22.2813 18.2933 24.0039 18.7641 25.8272C18.9081 26.3845 19.3942 26.7829 19.963 26.8191C19.3939 26.7832 18.9074 26.3847 18.7633 25.8272C18.2925 24.0038 17.5698 22.2812 16.6349 20.6992ZM26.1792 26.8311C26.8367 26.9094 27.347 27.4694 27.347 28.1478V33.4522C27.347 34.1842 26.753 34.7783 26.021 34.7783H20.0469C19.4422 34.7783 18.9145 35.188 18.7633 35.7728C18.2925 37.5962 17.5698 39.3188 16.6349 40.9008C16.3273 41.422 16.4108 42.085 16.8391 42.5133L21.0654 46.7409C21.5839 47.2581 21.5839 48.0975 21.0654 48.616L17.3152 52.3662C17.0348 52.6466 16.6605 52.7753 16.2941 52.7524C16.6607 52.7756 17.0354 52.6468 17.316 52.3662L21.0662 48.616C21.5847 48.0975 21.5847 47.2581 21.0662 46.7409L16.8399 42.5134C16.4116 42.0851 16.328 41.422 16.6357 40.9009C17.5706 39.3188 18.2933 37.5962 18.7641 35.7729C18.9152 35.1881 19.443 34.7783 20.0477 34.7783H26.0217C26.7537 34.7783 27.3478 34.1842 27.3478 33.4522V28.1479C27.3478 27.4691 26.837 26.909 26.1792 26.8311ZM10.1517 13.843C9.9616 13.8252 9.77342 13.7663 9.60081 13.6644C8.01879 12.7295 6.2962 12.0067 4.47283 11.536C3.88802 11.3848 3.47826 10.857 3.47826 10.2523V4.27831C3.47826 3.59679 2.96329 3.03483 2.3015 2.96056C2.96291 3.03518 3.47748 3.59701 3.47748 4.27826V10.2523C3.47748 10.857 3.88724 11.3848 4.47205 11.5359C6.29541 12.0067 8.01801 12.7294 9.60003 13.6643C9.77287 13.7663 9.96133 13.8253 10.1517 13.843Z"
                  fill="#284480"
                />
              </svg>
              <div
                className={
                  "d-flex justify-content-start flex-column align-items-start ps-3"
                }
              >
                <div
                  style={{
                    fontSize: "26px",
                    color: "#000000",
                    fontWeight: "600",
                  }}
                >
                  {parsePortAssignment(data.port_assignment, outputNumber)}
                </div>
                <div
                  style={{
                    color: "#284480",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  Ajuste
                </div>
              </div>
            </div>
            <FontAwesomeIcon
              icon={faX}
              color={"#6A86C8"}
              size={"lg"}
              className={"pe-3"}
              role={"button"}
              onClick={() => {
                setIsOpen(false);
              }}
            />
          </div>

          <div className={styles.header}>
            <div
              className={`${styles.section} ${
                section === "shutdown" && styles.active
              }`}
              onClick={() => setSection("amp")}
            >
              <svg
                width="9"
                height="19"
                viewBox="0 0 9 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.556 19L2.38128 13.7473L3.32601 11.187H0.299336C0.187632 11.1891 0.0854376 11.1321 0.0331495 11.0409C-0.0179491 10.9487 -0.00962897 10.8389 0.0557278 10.7555L8.44044 0L6.61516 5.25266L5.67399 7.81415H8.70066C8.81237 7.81195 8.91456 7.86904 8.96685 7.96017C9.01795 8.05239 9.00963 8.16219 8.94427 8.24563L0.556 19Z"
                  fill="#284480"
                />
              </svg>
              <div className={"ps-2"}>Límite de Amperaje</div>
            </div>
            <div
              className={`${styles.section} ${
                section === "amp" && styles.active
              }`}
              onClick={() => setSection("shutdown")}
            >
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.341 2.32386C10.1053 2.20597 9.83578 2.18912 9.58315 2.27333C9.33052 2.35755 9.12841 2.54281 9.01052 2.7786C8.77473 3.26702 8.97684 3.87333 9.4821 4.10912C11.2674 4.96807 12.4126 6.80386 12.4126 8.79122C12.4126 11.6544 10.0716 13.9954 7.20842 13.9954C4.34526 13.9954 2.00421 11.6544 2.00421 8.79122C2.00421 6.80386 3.14947 4.96807 4.93473 4.10912C5.44 3.87333 5.6421 3.26702 5.40631 2.7786C5.28842 2.54281 5.08631 2.35755 4.83368 2.27333C4.58105 2.18912 4.31158 2.20597 4.07579 2.32386C1.6 3.50281 0 6.04596 0 8.79122C0 12.766 3.23368 15.9996 7.20842 15.9996C11.1831 15.9996 14.4168 12.766 14.4168 8.79122C14.4168 6.04596 12.8168 3.50281 10.341 2.32386Z"
                  fill="#6A86C8"
                />
                <path
                  d="M7.20853 5.81052C7.76432 5.81052 8.20221 5.35579 8.20221 4.81684V0.993683C8.20221 0.437894 7.74747 0 7.20853 0C6.65274 0 6.21484 0.454736 6.21484 0.993683V4.8C6.21484 5.35579 6.65274 5.81052 7.20853 5.81052Z"
                  fill="#6A86C8"
                />
              </svg>
              <div className={"ps-2"}>Apagado Amigable</div>
            </div>
          </div>
          {section === "amp" ? (
            <Amp
              setSettings={setSettings}
              settings={settings}
              ampUsage={
                ports12v.includes(outputNumber) ? ampUsage12v : ampUsage24v
              }
              ampLimit={
                ports12v.includes(outputNumber) ? ampLimit12v : ampLimit24v
              }
              portIs12Or24={ports12v.includes(outputNumber)}
            />
          ) : (
            <Shutdown setSettings={setSettings} settings={settings} />
          )}
          <ModalFooter submit={submit} submitLoading={submitLoading}>
            {section === "shutdown" && (
              <div style={{ textAlign: "left" }}>
                * Tiempo en el que se mantendrá la señal de chapa en OFF hasta
                desenergizar el puerto
              </div>
            )}
            {error && (
              <div style={{ color: "#d53c3c", fontWeight: 600 }}>{error}</div>
            )}
          </ModalFooter>
          <div className={"mb-4"} />
        </Modal>
      )}
    </div>
  );
}
